import Button from './Button';
import { BUTTON_LOOK, BADGE_POSITION, BADGE_PLACEMENT } from './Button.types';
export type { ButtonProps } from './Button.types';

export default Button;

export { BUTTON_LOOK, BADGE_POSITION, BADGE_PLACEMENT };
